module.exports = __webpack_public_path__ + "assets/img/thesis_placeholder.a61da6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/previews/thesis_placeholder.jpg
// module id = 50
// module chunks = 0